import React, { useState } from "react";
import SponsorshipModal from "./SponsorshipModal";

const SponsorshipTable = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const packagePrices = {
    Silver: 1800,
    Gold: 2400,
    Platinum: 2800,
  };

  const rows = [
    ["Logo placement on Event Website", "✔", "✔", "✔"],
    ["Mention in Email Blast (sent to delegates & subscribers)", "✔", "✔", "✔"],
    ["Advertisement on Conference Brochure (Digital PDF)", "Half Page", "Full Page", "Full Page"],
    ["Promotion on Social Media (LinkedIn, Twitter, etc.)", "✔ (1 Post)", "✔ (2 Posts)", "✔ (3 Posts)"],
    ["Banner/Logo in Virtual Lobby", "-", "✔", "✔"],
    ["Conference Access", "Silver", "Gold", "Platinum"],
    ["Full access to all sessions", "✔", "✔", "✔"],
    ["Virtual Networking Lounge Access", "✔", "✔", "✔"],
    ["Premium Delegate Passes", "2", "3", "4"],
    ["Speaking Slot (20 minutes, includes Q&A)", "-", "1", "1"],
    ["Virtual Booth / Showcase Page", "-", "✔", "✔ (Premium Placement)"],
    ["Literature Distribution (Digital Materials shared with delegates)", "", "✔", "✔"],
  ];

  const handleBookNow = (pkg) => {
    setSelectedPackage(pkg);
    setShowModal(true);
  };

  return (
    <section style={{ padding: "60px 0", backgroundColor: "#f8f9fa", fontFamily: "'Inter', sans-serif" }}>
      <div className="container">
        <div style={{ overflowX: "auto", background: "#fff", borderRadius: "12px", boxShadow: "0 6px 20px rgba(0,0,0,0.05)" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "850px" }}>
            <thead>
              <tr style={{ backgroundColor: "#002855", color: "#fff" }}>
                <th style={{ padding: "15px", textAlign: "center", fontWeight: "700", fontSize: "1rem" }}>
                  Branding & Promotions
                </th>
                <th style={{ padding: "15px", textAlign: "center", fontWeight: "700", fontSize: "1rem" }}>
                  Silver Package<br />USD 1800
                </th>
                <th style={{ padding: "15px", textAlign: "center", fontWeight: "700", fontSize: "1rem" }}>
                  Gold Package<br />USD 2400
                </th>
                <th style={{ padding: "15px", textAlign: "center", fontWeight: "700", fontSize: "1rem" }}>
                  Platinum Package<br />USD 2800
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#f9f9f9" : "#fff", borderBottom: "1px solid #ddd" }}>
                  {row.map((cell, i) => (
                    <td
                      key={i}
                      style={{
                        padding: "14px",
                        textAlign: i === 0 ? "left" : "center",
                        fontSize: "0.95rem",
                        fontWeight: i === 0 ? "500" : "400",
                        color: "#333",
                      }}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}

              {/* CTA Buttons Row */}
              <tr>
                <td></td>
                {["Silver", "Gold", "Platinum"].map((pkg, idx) => (
                  <td key={idx} style={{ textAlign: "center", padding: "20px" }}>
                    <button
                      onClick={() => handleBookNow(pkg)}
                      style={{
                        background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                        color: "#fff",
                        border: "none",
                        padding: "10px 30px",
                        borderRadius: "8px",
                        fontWeight: "600",
                        cursor: "pointer",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                        transition: "0.3s ease",
                      }}
                    >
                      Book Now
                    </button>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <SponsorshipModal
          selectedPackage={selectedPackage}
          price={packagePrices[selectedPackage]}
          onClose={() => setShowModal(false)}
        />
      )}
    </section>
  );
};

export default SponsorshipTable;
